var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getVendorUserList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-4 col-xl-4" },
              [
                _c("c-vendor", {
                  attrs: {
                    label: "수급업체",
                    name: "vendorCd",
                    disabled: Boolean(_vm.popupParam.vendorCd),
                  },
                  on: { input: _vm.getList },
                  model: {
                    value: _vm.searchParam.vendorCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "vendorCd", $$v)
                    },
                    expression: "searchParam.vendorCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "vendorUserTable",
          attrs: {
            title: "수급업체 근무인원",
            tableId: "vendorUserTable",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            usePaging: false,
            columnSetting: false,
            isExcelDown: false,
            isFullScreen: false,
            selection: _vm.popupParam.type,
            rowKey: "vendorUserCd",
          },
          on: { rowDblclick: _vm.rowDblclick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSELECT", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }